import React from "react";
import { Link } from "react-router-dom";
import "assets/scss/sidemenu.scss";
import { Menubar } from "primereact/menubar";
import { color } from "@amcharts/amcharts5";

function TopMenu() {
  const itemRenderer = (item) => (
    <Link
      to={item.link}
      className="flex align-items-center p-menuitem-link"
      style={{ textDecoration: "none" }}
    >
      <i className={`${item.icon} me-2`} />
      <span className="mx-0" style={item.label === "Poll Data Workflow Status" ? {color: "red",textDecoration: "none"}:{textDecoration: "none"}}>
        {item.label}
      </span>
    </Link>
  );

  const items = [
    {
      label: "LD-PDCS",
      template: () => (
        <span
          className="inline-flex align-items-center gap-1 px-2 py-2 text-xl"
          style={{
            color: "white",
            textDecoration: "underline dotted",
            backgroundColor: "black",
            fontWeight: "normal",
          }}
        >
          LD-PDCS
        </span>
      ),
    },
    {
      label: "Charts",
      items: [
        {
          label: "Machine",
          template: () => <span className="dropdown-heading">Machine</span>,
        },
        {
          label: "Efficiency - Operation Time",
          link: "/charts/EffOpTime",
          icon: "fas fa-chart-line",
          template: itemRenderer,
        },
        {
          label: "Efficiency - Units Produced",
          link: "/charts/EffUnit",
          icon: "fas fa-chart-line",
          template: itemRenderer,
        },
        {
          label: "Machine Stops",
          link: "/charts/MachineStops",
          icon: "fas fa-chart-pie",
          template: itemRenderer,
        },
        {
          label: "CA | VA Checker Running Totals",
          link: "/charts/VAChecker",
          icon: "fas fa-chart-area",
          template: itemRenderer,
        },
        {
          label: "TPA | Inspection NG",
          link: "/charts/TPAInsNG",
          icon: "fas fa-chart-bar",
          template: itemRenderer,
        },
        {
          label: "Line",
          template: () => <span className="dropdown-heading">Lines</span>,
        },
        {
          label: "Pareto | Machine Stops",
          link: "/charts/ParetoMachStops",
          icon: "fas fa-chart-line",
          template: itemRenderer,
        },
        {
          label: "Pareto | Reject Ratio",
          link: "/charts/ParetoRejectsMach",
          icon: "fas fa-chart-line",
          template: itemRenderer,
        },
        {
          label: "Wait Times",
          link: "/charts/LineWaitChart",
          icon: "fas fa-chart-bar",
          template: itemRenderer,
        },
        { separator: true },
        {
          label: "Weight Checker",
          command: () => window.open("http://pecaweb.mbiabattery.com/ldreports/public/WeightScaleCharts.aspx", '_blank'),
          icon: "fas fa-chart-bar",
          template: itemRenderer,
        },
      ],
    },
    {
      label: "Dashboards",
      items: [
        // {
        //   label: "Cell Assembly",
        //   command: () => window.open("/Dashboards/CellAssembly", '_blank'),
        //   icon: "fas fa-tachometer-alt",
        //   template: itemRenderer,
        // },
        // {
        //   label: "Top Plate Assembly",
        //   command: () => window.open("/Dashboards/TPADashboards", '_blank'),
        //   icon: "fas fa-tachometer-alt",
        //   template: itemRenderer,
        //},
        {
          label: "Top Plate/Cell Assembly",
          command: () => window.open("https://pecaweb.mbiabattery.com/Visualization/dashboard/Assembly/Index/", '_blank'),
          icon: "fa-duotone fa-fw fa-screen-users me-1",
          template: itemRenderer,
        },
        {
          label: "Production Status",
          command: () => window.open("https://pecaweb.mbiabattery.com/Visualization/dashboard/ProductionStatus/Index/", '_blank'),
          icon: "fa-duotone fa-fw fa-screen-users me-1",
          template: itemRenderer,
        },
        {
          label: "Final Inspection",
          command: () => window.open("https://pecaweb.mbiabattery.com/Visualization/dashboard/FinalInspection/Index/", '_blank'),
          icon: "fa-duotone fa-fw fa-screen-users me-1",
          template: itemRenderer,
        },
        {
          label: "Line",
          template: () => <span className="dropdown-heading">FI Cells</span>,
        },
        {
          label: "123A",
          command: () => window.open("https://pecaweb.mbiabattery.com/Visualization/dashboard/FinalInspection/Cell/123A", '_blank'),
          icon: "fa-duotone fa-fw fa-battery-full me-1",
          template: itemRenderer,
        },
        {
          label: "2/3A + 2/3AZ + 2/3AU",
          command: () => window.open("https://pecaweb.mbiabattery.com/Visualization/dashboard/FinalInspection/Cell/2/3A", '_blank'),
          icon: "fa-duotone fa-fw fa-battery-full me-1",
          template: itemRenderer,
        },
      ],
    },
    {
      label: "Operator Entry",
      items: [
        {
          label: "Top Plate Assembly",
          command: () => window.open("https://pecaweb.mbiabattery.com/ldCollection/account", '_blank'),
          icon: "fa-duotone fa-fw fa-lock me-1 text-warning",
          template: itemRenderer,
        },
      ],
    },
    {
      label: "Poll Data",
      items: [
        {
          label: "Poll Data Interface Runs",
          link: "/PollData/PollDataInterfaceRuns",
          icon: "fas fa-database",
          template: itemRenderer,
        },
         {
          label: "No Poll Data Days",
          link: "/PollData/NoPollDataDays",
          icon: "fas fa-exclamation-triangle",
          template: itemRenderer,
        },
        {
          label: "Poll Data Workflow Status",
          link: "/PollData/WorkFlowStatus",
          icon: "fas fa-project-diagram",
          template: itemRenderer,
        },
        {
          label: "PDCS Scheduler Jobs",
          link: "/PollData/SchedulerJobs",
          icon: "fas fa-list-check",
          template: itemRenderer,
        },
        {
          label: "Poll Data Err Summary",
          link: "/PollData/ErrorSummary",
          icon: "fas fa-exclamation-circle",
          template: itemRenderer,
        },
        {
          label: "Poll Data Err Details",
          link: "/PollData/DeviceExplorerLoggingSettingError",
          icon: "fas fa-book",
          template: itemRenderer,
        },
        {
          label: "Poll Data Col Map Errors",
          link: "/PollData/PollDataColumns",
          icon: "fas fa-map",
          template: itemRenderer,
        },
        {
          label: "Poll Data Errors",
          link: "/PollData/PollDataErrors",
          icon: "fas fa-times-circle",
          template: itemRenderer,
        },
        {
          label: "Legacy Poll Data Archives",
          link: "/PollData/PollDataArchives",
          icon: "fas fa-archive",
          template: itemRenderer,
        },
      ],
    },
    {
      label: "Admin Pages",
      items: [
        {
          label: "System",
          items: [
            {
              label: "Options",
              link: "/AdminPages/System/SystemOptions",
              icon: "fas fa-sliders-h",
              template: itemRenderer,
            },
            {
              label: "Users",
              link: "/AdminPages/System/Users",
              icon: "fas fa-user-alt",
              template: itemRenderer,
            },
            {
              label: "Lookups",
              link: "/AdminPages/System/LookupValues",
              icon: "fas fa-search",
              template: itemRenderer,
            },
            {
              label: "Messages",
              link: "/AdminPages/System/Messages",
              icon: "fas fa-envelope",
              template: itemRenderer,
            },
          ],
        },
        {
          label: "Setups",
          items: [
            {
              label: "Machines",
              link: "/AdminPages/Setups/machines",
              icon: "fas fa-industry",
              template: itemRenderer,
            },
            {
              label: "Shift Types",
              link: "/AdminPages/Setups/shiftTypes",
              icon: "fas fa-file-export",
              template: itemRenderer,
            },
            {
              label: "Machine Addresses",
              link: "/AdminPages/Setups/MachineAddress",
              icon: "fas fa-map-marker-alt",
              template: itemRenderer,
            },
            {
              label: "ExtractOPC/DLogData",
              link: "/AdminPages/Setups/ExtractOPCDataLogger",
              icon: "pi pi-wrench",
              template: itemRenderer,
            },
            {
            label: "Machine/MG",
            items: [
              {
                label: "Processes",
                link: "/AdminPages/Setups/MachineMG/processNames",
                icon: "fas fa-stream",
                template: itemRenderer,
              },
              {
                label: "MG-Machines",
                link: "/AdminPages/Setups/MachineMG/mgMachines",
                icon: "fas fa-industry",
                template: itemRenderer,
              },
            ],
            
          },
          {
            label: "System",
            items: [
              {
                label: "Tablet MG",
                link: "/AdminPages/Setups/System/TabletMG",
                icon: "fas fa-tablet-alt",
                template: itemRenderer,
              },
            ],
          },
          {
            label: "DownTimes",
            items: [
              {
                label: "DownTime Type",
                link: "/AdminPages/Setups/DownTimes/DownTimeType",
                icon: "fas fa-stream",
                template: itemRenderer,
              },
              {
                label: "DownTime Type Code",
                link: "/AdminPages/Setups/DownTimes/DownTimeTypeCode",
                icon: "fas fa-stream",
                template: itemRenderer,
              },
            ],
          },
          {
            label: "UseLots",
            items: [
              {
                label: "UseLot Type",
                link: "/AdminPages/Setups/UseLots/UseLotType",
                icon: "fas fa-stream",
                template: itemRenderer,
              },
            ],
          },
          {
            label: "Verifications",
            items: [
              {
                label: "Machine-Form Detail Assignments",
                link: "/AdminPages/Setups/Verifications/MachineFormDetailAssignments",
                icon: "fas fa-stream",
                template: itemRenderer,
              },
            ],
          },
          {
            label: "Defects",
            items: [
              {
                label: "Defect Type",
                link: "/AdminPages/Setups/Defects/DefectType",
                icon: "fas fa-stream",
                template: itemRenderer,
              },


              {
                label: "Defect Type Codes ",
                link: "/AdminPages/Setups/Defects/DefectTypeCodes",
                icon: "fas fa-stream",
                template: itemRenderer,
              },

              {
                label: "Machine Defect Assignments ",
                link: "/AdminPages/Setups/Defects/MachineDefectAssignments",
                icon: "fas fa-stream",
                template: itemRenderer,
              },       
              
              
            ],
          },
          {
            label: "Non-Work Time",
            items: [
              {
                label: "Non-Work Type",
                link: "/AdminPages/Setups/NonWorkTime/NonWorkType",
                icon: "fas fa-stream",
                template: itemRenderer,
              },
              {
                label: "Machine Non-Work Code Assignment",
                link: "/AdminPages/Setups/NonWorkTime/MachineNonWorkCodeAssignment",
                icon: "fas fa-stream",
                template: itemRenderer,
              },
            ],
          },
        ],
        },
        
        {
          label: "DataLogger Setups",
          items: [
            {
              label: "Events",
              link: "/AdminPages/DataLoggerSetups/Events",
              icon: "fas fa-calendar-check",
              template: itemRenderer,
            },
            {
              label: "Communications",
              link: "/AdminPages/DataLoggerSetups/Communications",
              icon: "fas fa-comments",
              template: itemRenderer,
            },
            {
              label: "Tags",
              link: "/AdminPages/DataLoggerSetups/Tags",
              icon: "fas fa-tags",
              template: itemRenderer,
            },
            {
              label: "Loggings",
              link: "/AdminPages/DataLoggerSetups/DxpDataLoggers",
              icon: "fas fa-file-alt",
              template: itemRenderer,
            },
            {
              label: "Logging Details",
              link: "/AdminPages/DataLoggerSetups/DxpDataLoggersLogDet",
              icon: "fas fa-list-alt",
              template: itemRenderer,
            },
            {
              label: "Event Details",
              link: "/AdminPages/DataLoggerSetups/DxpDataLoggersLogDetEvent",
              icon: "fas fa-calendar-day",
              template: itemRenderer,
            },
            {
              label: "Event Triggers",
              link: "/AdminPages/DataLoggerSetups/DxpDataLoggersEventTrig",
              icon: "fas fa-bell",
              template: itemRenderer,
            },
            {
              label: "Import Configs",
              link: "#",
              icon: "fas fa-upload",
              template: itemRenderer,
            },
          ],
        },
        {
          label: "OPC Server Setups",
          items: [
            {
              label: "Communications",
              link: "/AdminPages/OPCServerSetups/Communications",
              icon: "fas fa-cogs",
              template: itemRenderer,
            },
            {
              label: "Devices",
              link: "/AdminPages/OPCServerSetups/OPCcommDevice",
              icon: "fas fa-industry",
              template: itemRenderer,
            },
            {
              label: "DeviceTags",
              link: "/AdminPages/OPCServerSetups/OPCDeviceTags",
              icon: "fas fa-map-marker-alt",
              template: itemRenderer,
            },
            {
              label: "Import OPC Server Setups",
              link: "/AdminPages/OPCServerSetups/OPCServerImportData",
              icon: "fas fa-file-import",
              disabled: true,
              template: itemRenderer,
            },
          ],
        },
        {
          label: "Shipments Audit",
          items: [
            {
              label: "Summary Data",
              link: "/AdminPages/ShipmentsAudit/ShipmentSummary",
              icon: "fas fa-file-invoice",
              template: itemRenderer,
            },
            {
              label: "Detail Data",
              link: "/AdminPages/ShipmentsAudit/ShipmentDetail",
              icon: "fas fa-eye",
              template: itemRenderer,
            },
          ],
        },
      ],
    },
    {
      label: "Customer UCC",
      items: [
        {
          label: "Preprint Customer UCC Label",
          link: "/CustomerUCC/customerUCCLabel",
          icon: "fa fa-tags",
          template: itemRenderer,
        },
        {
          label: "Update LPN for EDI ASN",
          link: "/CustomerUCC/updateLPN",
          icon: "fas fa-edit",
          template: itemRenderer,
        },
      ],
    },
  ];

  return <Menubar model={items} />;
}

export default TopMenu;
